import { z } from "zod";

export const audioSettingsSchema = z.object({
    inputSensitivity: z.number().int().min(0).max(100).optional(),
    outputVolume: z.number().int().min(0).max(100).optional(),
    micMuted: z.boolean().optional(),
    speakerMuted: z.boolean().optional(),
    selectedMic: z.string().nullable().optional(),
    selectedSpeaker: z.string().nullable().optional(),
});

export const settingsSchema = z.object({
    audio: audioSettingsSchema.optional(),
    voiceMessages: z
        .object({
            tts: z.object({ language: z.string(), voice: z.string() }).optional(),
            call: z.object({ noAgentsAvailable: z.string().min(1).max(500).optional() }).optional(),
            recording: z.object({ recordingNotice: z.string().min(1).max(500).optional() }).optional(),
            queue: z
                .object({
                    connecting: z.string().min(1).max(500).optional(),
                    waiting: z.string().min(1).max(500).optional(),
                })
                .optional(),
            voicemail: z.object({ greeting: z.string().min(1).max(500).optional() }).optional(),
        })
        .nullable()
        .optional(),
});

export const updateCompanyCallFlowConfigSchema = z
    .object({
        recordCallsEnabled: z.boolean().optional(),
        voicemailEnabled: z.boolean().optional(),
    })
    .refine(
        (data) =>
            data.recordCallsEnabled !== undefined ||
            data.voicemailEnabled !== undefined,
        {
            message:
                "At least one config field must be provided",
        }
    );

export type UpdateCompanyCallFlowConfigPayload = z.infer<
    typeof updateCompanyCallFlowConfigSchema
>;